import React from "react";

interface IBackdropProps {
    show: boolean;
    bgColor?: string;
}

const BackdropLoader: React.FC<IBackdropProps> = ({ show, bgColor }) => {
    return (
        <>
            <div
                id="loader-backdrop"
                style={{
                    display: `${show ? "unset" : "none"}`,
                    zoom: "1.5",
                    position: "absolute",
                    left: 0,
                    top: "3rem",
                    bottom: "1rem",
                    width: "100%",
                    zIndex: "10000",
                    background: `${bgColor || "rgb(247,250,250,0.7)"}`,
                }}
            >
                <i
                    className="spinner-border text-secondary"
                    style={{
                        position: "absolute",
                        top: "40%",
                        left: "45%",
                        width: "3rem",
                        height: "3rem",
                    }}
                />
            </div>
        </>
    );
};

export default BackdropLoader;
